<template>
  <div class="content">
    <template>
      <v-card
        :class="{'card-success': cadastro, 'card-warn': !cadastro}"
        style="min-height: 60vh"
      >
        <h4 v-if="!cadastro" slot="header" class="card-title text-center">
          Edição de Consultor
        </h4>
        <h4 v-else slot="header" class="card-title text-center">
          Cadastro de Consultor
        </h4>
        <div class="clearfix" />
        <div v-if="loading" style="height: 60vh">
          <v-row
            class="fill-height ma-2 flex-column"
            align="center"
            justify="center"
          >
            <v-progress-circular :size="70" color="primary" indeterminate />
          </v-row>
        </div>
        <div v-if="!loading">
          <v-form
            id="form"
            ref="form"
            v-model="valid"
            class="pa-3"
            lazy-validation
            @submit.prevent="updateProfile"
          >
            <v-card>
              <v-list-item-content>
                <v-card-title class="headline mx-auto">
                  Dados do Consultor
                </v-card-title>
                <v-row v-if="!loading" class="pa-3">
                  <v-col cols="6">
                    <v-text-field
                      v-model="form.nome"
                      label="Nome *"
                      :rules="requiredRules"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="form.cpf"
                      v-mask="maskCpf"
                      label="CPF *"
                      :rules="requiredRules"
                      return-masked-value
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.email"
                      label="Email *"
                      :rules="emailRules"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="form.estado"
                      label="Estado *"
                      :rules="requiredRules"
                      :items="estado"
                      item-text="nome"
                      item-value="id"
                      :disabled="disableState"
                      @change="changeCidade"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="form.cidade"
                      label="Cidade *"
                      :rules="requiredRules"
                      :items="cidade"
                      item-text="nome"
                      item-value="id"
                      :disabled="disableCidade"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="form.endereco"
                      label="Endereço *"
                      :rules="requiredRules"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="form.telefone"
                      v-mask="maskTelFixo"
                      label="Telefone *"
                      type="tel"
                      :rules="requiredRules"
                      return-masked-value
                    />
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-card>
            <v-btn
              type="submit"
              :disabled="salvando"
              :loading="salvando"
              :color="!$route.params.consultorKey ? 'success' : 'warning'"
              form="form"
            >
              {{ btnNome }}
            </v-btn>

            <router-link :disabled="salvando" to="listar-consultores">
              <v-btn :disabled="salvando" color="error" class="ml-3">
                Cancelar
              </v-btn>
            </router-link>
          </v-form>
        </div>
      </v-card>
    </template>
  </div>
</template>
<script>
export default {
  data() {
    return {
      salvando: false,
      loading: true,
      maskCpf: '###.###.###-##',
      maskTelFixo: '(##) #####-####',
      emailRules: [v => /.+@.+/.test(v) || 'E-mail invalido'],
      requiredRules: [v => !!v || '* Obrigatório'],
      valid: null,
      disableCidade: '',
      disableState: '',
      btnNome: !this.$route.params.consultorKey
        ? 'Salvar'
        : 'Salvar Alterações',
      form: {
        consultorKey: null, // codigo do consultor
        nome: '',
        cpf: '',
        email: '',
        cidade: '',
        estado: '',
        endereco: '',
        telefone: '',
      },
      estado: [{nome: 'Carregando', id: 0}],
      cidade: [{nome: 'Carregando', id: 0}],
      cadastro: this.$route.params.consultorKey === 0 ? 1 : 0,
    }
  },
  created() {
    // console.log(this.$route.params.consultorKey)
    if (this.$route.params.consultorKey === undefined) {
      // console.log('Indefinido')
      this.$router.push({name: 'Listar Consultores'})
    } else if (this.$route.params.consultorKey !== 0) {
      // console.log('edicao')
      this.form.consultorKey = this.$route.params.consultorKey
      // console.log(this.form.consultorKey)
      this.formDados()
    } else {
      // console.log('cadastro')
      this.loadNewForm()
    }
  },
  methods: {
    loadNewForm() {
      this.loadEstado()
      this.loading = false
    },
    updateProfile() {
      this.$refs.form.validate()
      if (!this.valid) {
        this.Swal.fire(
          'Atenção',
          'Preencha os itens obrigatórios sinalizados com ("*").',
          'warning',
        )
      } else {
        if (typeof this.form.estado === 'object') {
          this.form.estado = this.form.estado.id
        }

        if (typeof this.form.cidade === 'object') {
          this.form.cidade = this.form.cidade.id
        }
        this.salvando = true
        if (this.form.consultorKey) {
          // ATUALIZAR DADOS CONSULTOR
          this.alert = false
          this.api
            .put('/consultor/attConsultor', this.form)
            .then(response => {
              this.salvando = false
              if (response.data.error) {
                let erros = ''
                response.data.message.forEach(el => {
                  erros += el + '<br/>'
                })
                this.Swal.fire({
                  title: 'Corrija os erros abaixo:',
                  icon: 'warning',
                  html: erros,
                })
              } else {
                this.Swal.fire('Sucesso', 'Atualização Realizada', 'success')
                this.$router.push({name: 'Listar Consultores'})
              }
            })
            .catch(error => {
              this.salvando = false
              this.Swal.fire({
                title: 'Atenção:',
                icon: 'warning',
                html: error,
              })
            })
        } else {
          // CRIAR NOVO CONSULTOR
          // console.log(this.form)
          this.api
            .post('/consultor/createConsultor', this.form)
            .then(response => {
              this.salvando = false
              if (response.data.error) {
                let erros = ''
                response.data.message.forEach(el => {
                  erros += el + '<br/>'
                })
                this.Swal.fire({
                  title: 'Corrija os erros abaixo:',
                  icon: 'warning',
                  html: erros,
                })
              } else {
                this.Swal.fire('Sucesso', 'Cadastro Realizado', 'success')
                this.$router.push({name: 'Listar Consultores'})
              }
            })
            .catch(error => {
              this.salvando = false
              this.Swal.fire({
                title: 'Atenção:',
                icon: 'warning',
                html: error,
              })
            })
        }
      }
    },
    formDados() {
      // console.log(this.form.consultorKey)
      this.api
        .get('/consultor/getDadosConsultor', {
          params: {
            consultorKey: this.form.consultorKey,
          },
        })
        .then(response => {
          this.form.nome = response.data[0].nome
          this.form.cpf = response.data[0].cpf
          this.form.email = response.data[0].email
          this.form.endereco = response.data[0].endereco
          this.form.telefone = response.data[0].telefone
          this.form.cidade = {nome: 'Carregando', id: 0}
          this.form.estado = {nome: 'Carregando', id: 0}
          this.loadEstadoEdit(response.data[0].estado, response.data[0].cidade)
          this.loading = false
        })
        .catch(error => {
          this.message = error
          // console.log(this.message)
        })
    },
    save(date) {
      this.$refs.menu.save(date)
    },
    loadEstado() {
      this.api('/estado')
        .then(response => {
          this.estado = response.data.estado
          this.disableState = false
        })
        .catch(error => {
          this.message = error
          // console.log(this.message)
        })
    },
    loadCidade(CodEstado) {
      this.api('/cidade', {
        params: {
          CodEstado: CodEstado,
        },
      })
        .then(response => {
          this.cidade = response.data.cidade
          this.disableCidade = false
          // console.log(response.data.cidade)
        })
        .catch(error => {
          this.message = error
          // console.log(this.message)
        })
    },
    loadEstadoEdit(CodEstado, CodCidade) {
      this.api('/estado')
        .then(response => {
          this.estado = response.data.estado
          this.form.estado = this.estado
          this.form.estado = this.form.estado[CodEstado - 1]
          this.loadCidadeEdit(CodCidade)
          this.disableState = false
          // console.log(response)
        })
        .catch(error => {
          this.message = error
          // console.log(this.message)
        })
    },
    loadCidadeEdit(CodCidade) {
      this.api('/cidade')
        .then(response => {
          this.cidade = response.data.cidade
          this.form.cidade = this.cidade[CodCidade - 1]
          // this.loading = false
          this.disableCidade = false
        })
        .catch(error => {
          this.message = error
          // console.log(this.message)
        })
    },
    changeCidade() {
      this.loadCidade(this.form.estado)
      this.form.cidade = ''
      // console.log(this.company.estado)
    },
  },
}
</script>
